export type PhantomRedirectParams = {
  data?: string;
  errorCode?: string;
  errorMessage?: string;
  nonce?: string;
  phantomPublicKey?: string;
  requestId?: string;
};

export type ParsePhantomRedirectParamsParams = {
  url: URL;
};

/**
 * Parses Phantom wallet redirect parameters from a URL.
 *
 * Extracts both success and error parameters from the redirect URL,
 * including encrypted response data or error information.
 *
 * @param params.url - The redirect URL containing Phantom parameters
 * @returns Object containing the parsed redirect parameters
 */
export const parsePhantomRedirectParams = ({
  url,
}: ParsePhantomRedirectParamsParams): PhantomRedirectParams => {
  const searchParams = url.searchParams;

  return {
    data: searchParams.get('data') ?? undefined,
    errorCode: searchParams.get('errorCode') ?? undefined,
    errorMessage: searchParams.get('errorMessage') ?? undefined,
    nonce: searchParams.get('nonce') ?? undefined,
    phantomPublicKey:
      searchParams.get('phantom_encryption_public_key') ?? undefined,
    requestId: searchParams.get('request_id') ?? undefined,
  };
};
